import Home from "@mui/icons-material/Home";
import AccountCircle from "@mui/icons-material/AccountCircle";
import Build from "@mui/icons-material/Build";
import ElectricCarIcon from "@mui/icons-material/ElectricCar";
import ElectricRickshawIcon from "@mui/icons-material/ElectricRickshaw";
import EvStationIcon from "@mui/icons-material/EvStation";
import Settings from "@mui/icons-material/Settings";

export interface RouteType {
  icon: any
  name: string
  route: string
  end?: boolean
}

export interface MochaRoutes {
  [key:string]: RouteType
}

export const routes: MochaRoutes = {
  acceptRequest: { icon: Build, name: "Accept Service Request", route: "/accept" },
  addVehicle: { icon: Build, name: "Add a vehicle", route: "/add_vehicle" },
  chargerDetails: { icon: EvStationIcon, name: "Charger Details", route: "/charger" },
  chargerList: { icon: EvStationIcon, name: "My Chargers", route: "/chargers" },
  config: { icon: Settings, name: "Configuration", route: "/config" },
  home: { icon: Home, name: "Home", route: "/" },
  onboarding: { icon: Build, name: "Onboarding", route: "/onboard" },
  onboardProvider: { icon: Build, name: "Onboard Provider", route: "/onboard_provider" },
  providerServiceList: { icon: Build, name: "Provider service", route: "/service_list" },
  receiverSignup: { icon: Build, name: "Request signup", route: "/receiver_signup" },
  requestCharge: { icon: Build, name: "Request a charge", route: "/request_charge" },
  requestDetails: { icon: ElectricRickshawIcon, name: "Request Details", route: "/request" },
  requestList: { icon: Build, name: "Open requests", route: "/request_list" },
  profile: { icon: AccountCircle, name: "Profile", route: "/profile", end: true },
  vehicleDetails: { icon: ElectricCarIcon, name: "Vehicle Details", route: "/vehicleDetails" },
  vehicleList: { icon: ElectricCarIcon, name: "My Vehicles", route: "/vehicles" },
};
